import React from "react";
import { getRiskColor } from "../utils/riskUtils";

const Footer = () => {
  const riskLevels = [
    { level: "CRITICAL", desc: "Carcinoma - Immediate attention" },
    { level: "HIGH", desc: "Adenoma - Urgent consultation" },
    { level: "MEDIUM", desc: "Polyps - Medical follow-up" },
    { level: "LOW", desc: "Normal - Routine monitoring" },
  ];

  return (
    <div
      style={{
        background: "white",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        textAlign: "center",
        marginTop: "30px",
        border: "1px solid #e9ecef",
      }}
    >
      {/* <h4 style={{ color: "#2c3e50", marginBottom: "15px" }}>
        🩺 Medical Risk Levels
      </h4>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          flexWrap: "wrap",
          marginBottom: "15px",
        }}
      >
        {riskLevels.map(({ level, desc }) => (
          <div
            key={level}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              margin: "5px 0",
            }}
          >
            <span
              style={{
                padding: "2px 8px",
                borderRadius: "12px",
                fontSize: "0.75rem",
                fontWeight: "600",
                textTransform: "uppercase",
                background: getRiskColor(level),
                color: "white",
              }}
            >
              {level}
            </span>
            <small style={{ color: "#666" }}>{desc}</small>
          </div>
        ))}
      </div> */}

      <p style={{ color: "#666", fontSize: "0.9rem", marginTop: "15px" }}>
        <strong>Powered by DxPSoftware</strong> • Research Use Only
      </p>
    </div>
  );
};

export default Footer;
